<input
  autocomplete="chrome-off"
  type="text"
  placeholder=""
  [formControl]="autocompleteInput"
  #addressText
  (blur)="onBlur()"
>
